// @ts-nocheck
import { Handler } from "@insite/client-framework/HandlerCreator";
import { CallApi, chain } from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/SendTracking";
import { sendTracking as sendTrackingApi } from "@store/Framework/Services/StoreProductRecommendationsService";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ json: string }>;

export const StoreCallApi: HandlerType = ({ parameter: { json } }) => {
    sendTrackingApi(json);
};
replaceInChain(chain, CallApi, StoreCallApi);
